const logoDictionary = {
    get: function (mandantId) {
        if (mandantId == 23) {
            return 'static/images/daa-stiftung-logo-mandant-23.png';
        }

        return 'static/images/daa-logo-mandant-2.png';
    }
}
export default logoDictionary;